import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { environment } from 'src/environments/environment';

function emailOrCustomerIdValidator(group: AbstractControl): ValidationErrors | null {
  const email = String(group.get('contact_email')?.value || '').trim();
  const customerId = String(group.get('customer_id')?.value || '').trim();
  if (!email && !customerId) {
    return { identityRequired: true };
  }
  return null;
}

@Component({
  selector: 'app-customer-data-deletion',
  templateUrl: './customer-data-deletion.component.html',
  styleUrls: ['./customer-data-deletion.component.scss'],
})
export class CustomerDataDeletionComponent implements OnInit {
  form!: FormGroup;
  isLoading = false;
  submitSuccess = false;
  submitError = false;
  submitMessage = '';
  requestId: number | null = null;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        contact_email: ['', [Validators.email]],
        customer_id: [''],
        reason: ['', [Validators.maxLength(2000)]],
        confirm: [false, [Validators.requiredTrue]],
      },
      { validators: emailOrCustomerIdValidator }
    );
  }

  get f() {
    return this.form.controls;
  }

  hasError(fieldName: string): boolean {
    const control = this.form.get(fieldName);
    return !!(control?.touched && control?.invalid);
  }

  get identityError(): boolean {
    return !!(
      (this.form.get('contact_email')?.touched ||
        this.form.get('customer_id')?.touched ||
        this.form.touched) &&
      this.form.errors?.['identityRequired']
    );
  }

  getFieldError(fieldName: string): string {
    const control = this.form.get(fieldName);
    if (!control?.touched || !control.errors) return '';
    if (control.errors['required'] || control.errors['requiredTrue']) {
      return 'This field is required.';
    }
    if (control.errors['email']) {
      return 'Please enter a valid email address.';
    }
    if (control.errors['maxlength']) {
      return 'Reason is too long (max 2000 characters).';
    }
    return 'Invalid value.';
  }

  onSubmit(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;

    this.isLoading = true;
    this.submitSuccess = false;
    this.submitError = false;
    this.submitMessage = '';
    this.requestId = null;

    const val = this.form.value;
    const payload = {
      contact_email: String(val.contact_email || '').trim() || undefined,
      customer_id: String(val.customer_id || '').trim() || undefined,
      reason: String(val.reason || '').trim() || undefined,
      request_source: 'public_form',
    };

    this.http.post(environment.submitCustomerDataDeletionRequest, payload).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.submitSuccess = true;
        this.submitMessage =
          res?.message ||
          'Your data deletion request has been received and will be processed shortly.';
        this.requestId = res?.data?.id ?? null;
        this.form.reset({ confirm: false });
      },
      error: (err) => {
        this.isLoading = false;
        this.submitError = true;
        this.submitMessage =
          err?.error?.message ||
          'Could not submit your request. Please try again later.';
      },
    });
  }
}
